var exports = {
  "ns": "Attachment.module__attachmentWrapper___YjNjQW",
  "yf": "Attachment.module__expiredOverlay___YjNjQW",
  "ri": "Attachment.module__expiredContent___YjNjQW",
};

module.exports = exports;
